<template>
    <div class="SiteForm">
        <DashboardEditSection title="Information">
            <FormInput
                v-model="$v.name.$model"
                label="Site Name"
                :errors="$v.name.$error ? [
                    !$v.name.required && 'Site name is required',
                ] : null"
                required
            />
            <FormTextarea v-model="notes" label="Notes"/>
        </DashboardEditSection>

        <DashboardEditSection title="Address">
            <FormInput v-model="address1" label="Address Line 1"/>
            <FormInput v-model="address2" label="Address Line 2"/>
            <Row>
                <Column :md="6">
                    <FormInput v-model="city" label="City"/>
                </Column>
                <Column :md="3">
                    <FormSelectStateV2 v-model="state" label="State"/>
                </Column>
                <Column :md="3">
                    <FormInput v-model="zip" label="Zip"/>
                </Column>
            </Row>
        </DashboardEditSection>

        <EntityTagsSection :tags.sync="tags"/>
    </div>
</template>

<script>
import DashboardEditSection from '@/components/DashboardEditSection';
import EntityTagsSection from '@/components/form/EntityTagsSection';
import { required } from 'vuelidate/lib/validators';
import syncPropsMixin from '@/utils/syncPropsMixin';

export default {
    name: 'SiteForm',

    mixins: [syncPropsMixin],

    components: { DashboardEditSection, EntityTagsSection },

    props: {
        isEditMode: { type: Boolean, default: false },
    },

    syncProps: [
        'name',
        'address1',
        'address2',
        'city',
        'state',
        'zip',
        'notes',
        'tags',
    ],

    validations: {
        name: {
            required,
        },
    },

    methods: {
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },
    },
}
</script>